import React from 'react';
import App from '../../../../App/App';

const AppFreshWatch = (props: any) => <App {...props} />;
export default AppFreshWatch;
